import { IndicatorItem } from "./indicator-item"
import { CompositeField } from "../../../shared"
import { useState } from "react"
import { IndicatorModal } from "./indicator-modal"
import PropTypes from "prop-types"
import { Droppable } from "react-beautiful-dnd"
import { duplicateSpecificObjectiveSubItems } from "../../../../helpers/duplicate-specific-objective-subitems"
import { useAuth } from "../../../../contexts/auth"


IndicatorsField.propTypes = {
  defaultValue: PropTypes.array,
  indicatorType: PropTypes.string,
  objectiveIndex: PropTypes.number,
  onSave: PropTypes.func,
  onCancel: PropTypes.func,
  limitDates: PropTypes.array,
  readOnly: PropTypes.bool,
  onChange: PropTypes.func,
  hiddenComments: PropTypes.any,
  review: PropTypes.bool,
  removeIndicator: PropTypes.func
}

export function IndicatorsField({
  defaultValue,
  indicatorType,
  objectiveIndex,
  limitDates,
  onChange,
  readOnly,
  hiddenComments,
  review,
  removeIndicator,
  admin
}) {
  const [state, setState] = useState({ isModalOpen: false, edit: undefined })

  const auth = useAuth() || {}
   const { user } = auth

  const onClickAdd = () => {
    setState({ isModalOpen: true })
  }

  const onCancel = () => {
    setState({ isModalOpen: false, edit: undefined })
  }

  const onSave = (addNew, replaceItemAtIndex) => values => {
    if (typeof values.index === "undefined") {
      addNew(values)
    }
    else {
      const index = values.index
      delete values.index

      replaceItemAtIndex(index, values)
    }
    onCancel()
  }

  const onEdit = (data, index) => () => {
    const d = { index, ...data }
    setState({ isModalOpen: true, edit: d })
  }

  let roles=["IMPLEMENTER","IMPLEMENTER_TECHNICAL_MONITOR","IMPLEMENTER_ATTENDANCE_MONITOR", "IMPLEMENTER_FINANCIAL_MONITOR","IMPLEMENTER_EVALUATOR","IMPLEMENTER_COORDINATOR","IMPLEMENTER_SYSTEMATIZER"]
  let rol = roles.includes(user?.claims?.role)

  return (
    <CompositeField
      value={defaultValue}
      onChange={onChange}
      onClickAdd={onClickAdd}
      isAddDisabled={review}
      addLabel="Agregar indicador">
      {({ addNew, removeItem, replaceItemAtIndex, duplicateItem }) =>
        <Droppable
          droppableId={
            `${indicatorType}${indicatorType.includes("SPECIFIC_INDICATOR") ? `_${objectiveIndex}` : "" }`
          }>
          {droppableProvided => (
            <div ref={droppableProvided.innerRef} {...droppableProvided.droppableProps}>
              <IndicatorModal
                rol={rol}
                indicatorType={indicatorType}
                objectiveIndex={objectiveIndex}
                review={review}
                readOnly={readOnly}
                onCancel={onCancel}
                onSave={onSave(addNew, replaceItemAtIndex)}
                limitDates={limitDates}
                visible={state.isModalOpen}
                edit={state.edit}
                hiddenComments={hiddenComments} />
              {defaultValue?.map((indicator, idx) => ({ ...indicator, orderIndex: idx }))
              ?.map((item, index)  =>
                <IndicatorItem 
                  admin={admin}
                  rol={rol}
                  data={item}
                  index={index}
                  review={review}
                  readOnly={readOnly}
                  onDelete={event => {
                    removeItem(index)(event)
                    removeIndicator(item.id)
                  }}
                  onDuplicate={copiedItem => duplicateItem({
                    handleWithCustomLogic: duplicateSpecificObjectiveSubItems(copiedItem)
                  })}
                  commentID ={item.id}
                  onEdit={onEdit(item, index)}
                  indicatorType={indicatorType}
                  objectiveIndex={objectiveIndex}
                  key={`indicator_${item.orderIndex}`} />
                )}
              {droppableProvided.placeholder}
            </div>
          )}
        </Droppable>
      }
    </CompositeField>
  )
}
